import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-LN/report/MonthlySafetyScoreChart/.eu';

export interface MonthlySafetyScoreChartProps {
  selectedMonth: string;
  onSelectedMonth?: (month: string) => void;
  data: {score: number; date: string}[];
}

export default function MonthlySafetyScoreChart({selectedMonth, onSelectedMonth, data}: MonthlySafetyScoreChartProps) {
  return (
    <>
      <Environment.Eu>
        <Environment.Kia>
          <Eu
            selectedMonth={selectedMonth}
            onSelectedMonth={onSelectedMonth}
            data={data}
          />
        </Environment.Kia>
      </Environment.Eu>
    </>
  );
}
